// import shared css
// import('./scss/shared.scss');

// Content Slider Block
// 

if (document.querySelector('.js-splide')) {

    import('@splidejs/splide/dist/css/splide-core.min.css');
    import('./scss/components/_carousel.scss');
    import('./scss/components/blocks/_block-content-slider.scss');
    import('./js/components/splide.js');

}

if (document.querySelector('.responsive-nav')) {

    import('./js/components/navigation.js');

}

if (document.querySelector('.js-lightbox')) {

    import('fslightbox');

}

if (document.querySelector('.js-scroll-animate')) {

    import('./js/common/scroll-animation.js');

}


if (document.querySelector('.lozad')) {

    import('./js/common/lozad.js');

}

if (document.querySelector('.alpine-js')) {

    import('./js/common/alpine.js');

}

if (document.querySelector('#header')) {

    import('./js/common/scroll-trigger.js');

}

if (document.querySelector('.js-jumble')) {

    import('./js/common/text-animation.js');

}

// If a page has an a link with href containing 'clients',
// then import the clients overlay component
if (document.querySelector('a[href*="clients"]') || document.querySelector('button[href*="clients"]')) {

    import('./js/components/clients-overlay.js');

}

if (document.querySelector('.vimeo-player')) {

    import('./js/components/vimeo-player.js');

}

if (document.querySelector('.news-listings')) {

    import('./js/components/news-loader.js');

}

if (document.querySelector('#hero-video')) {

    import('./js/components/hero-video.js');

}
